export const Constants = {
  Events: {
    chosenLanguageChanged: 'chosen-language-changed',
    phoneNumberChanged: 'phone-number-changed', // phoneNumber: string
    scannerSizeMultiplierChanged: 'scanner-size-multiplier-changed', // scannerSizeMultiplier: number
    callButtonClicked: 'call-button-clicked',
    settingsButtonClicked: 'settings-button-clicked',
    refreshButtonClicked: 'refresh-button-clicked',
    messagesChanged: 'messages-changed',
    tourChanged: 'tour-changed',
    isLoading: 'is-loading',
  },

  LocalStorageKeys: {
    startedTour: 'ctl-dispotool-started-tour',
    phoneNumber: 'ctl-dispotool-phone-number',
    scannerSizeMultiplier: 'ctl-dispotool-scanner-size-multiplier',
  },

  refreshTourIntervalInSeconds: 20, // TODO: remote config

  maxAdditionalItemCount: 9 // TODO: remote config
};
